const accountSwitch = {
  path: 'accountSwitch',
  component: resolve => require(['../../../../components/pages/studentUnion/accountSwitch'], resolve)
}

export default accountSwitch
